import React from "react";
import { Check } from "lucide-react";
import { aboutPoints, images, company } from "../mock";

const About = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="rounded-[2rem] overflow-hidden shadow-xl">
              <img
                src={images.about}
                alt="Support worker assisting participant at home"
                className="w-full h-[440px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 sm:-right-8 hidden sm:block rounded-[1.5rem] overflow-hidden shadow-xl border-8 border-white w-48 h-48">
              <img
                src={images.care}
                alt="Compassionate hand holding"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div>
            <span className="text-sm font-bold uppercase tracking-widest text-[#5aa83a]">
              About MVSD
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#123c74] leading-tight">
              Caring for your loved ones like our own
            </h2>
            <p className="mt-5 text-slate-600 text-lg leading-relaxed">
              At {company.name}, we believe everyone deserves to feel valued,
              respected and truly at home. Guided by our name &mdash; {" "}
              <span className="font-semibold text-[#123c74]">
                Mission, Value, Service and Dedication
              </span>{" "}
              &mdash; we provide warm, personalised NDIS support that puts you
              and your goals first.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Our friendly team works alongside you and your family to build a
              support plan that fits your life, so you can focus on the things
              that make you happy.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {aboutPoints.map((point) => (
                <div key={point} className="flex items-start gap-3">
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-[#eef6e8] flex items-center justify-center shrink-0">
                    <Check className="h-4 w-4 text-[#5aa83a]" strokeWidth={3} />
                  </span>
                  <span className="text-slate-700 font-medium">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
